import React, { useState } from 'react';
import { Card, Col, Row } from 'antd';
import { fetchData } from '../../service/dataServices';

function CountryCard(props) {
  const [data, setData] = useState([]);
  const response = fetchData('/api/dashboard/group-country', data => setData(data));

  console.log('data', data);
  return (
    <Card
      loading={response.isLoading}
      title="List of Countries"
      headStyle={{ color: '#00000073', fontSize: '14px' }}
      bodyStyle={{ color: '#6c757d', height: '567px', overflow: 'scroll' }}
    >
      {data.map(row => (
        <Row>
          <Col span={21}>
            {row.x}
          </Col>
          <Col span={3}>
            {row.y}
          </Col>
        </Row>
      ))}
    </Card>
  );
}

export default CountryCard;
